import { ProfileView } from "@/components/profile-view";

export default function DashboardProfilePage() {
  return <ProfileView />;
}

